import { useTranslation } from "react-i18next";
import React from 'react';
import Loading from 'Components/Loading';
import './CardPreview.css';
export default function CardPreview({
  card,
  profile,
  profileLoading
}) {
  const {
    t
  } = useTranslation();

  if (profileLoading) {
    return <div className="modern-card-preview">
                <div className="card-loading">
                    <Loading />
                </div>
            </div>;
  }

  if (!card) {
    return <div className="modern-card-preview">
                <div className="card-empty-state">
                    <div className="empty-icon"><span role="img" aria-label="card index">📇</span></div>
                    <div style={{
          fontSize: '1rem',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: '4px',
          textTransform: 'uppercase'
        }}>{t("No card found")}</div>
                </div>
            </div>;
  }

  const extractSingleVal = name => {
    try {
      // eslint-disable-next-line no-mixed-operators
      let prop = card.properties ? card.properties.find(p => p && (p.name === name || name === 'prefix' && p.name && p.name.toLowerCase().includes('prefix') || name === 'suffix' && p.name && p.name.toLowerCase().includes('suffix'))) : null;

      if (!prop && profile && profile.properties) {
        // eslint-disable-next-line no-mixed-operators
        const profProp = profile.properties.find(p => p && (p.name === name || name === 'prefix' && p.name && p.name.toLowerCase().includes('prefix') || name === 'suffix' && p.name && p.name.toLowerCase().includes('suffix')));

        if (profProp) {
          const matchedProp = card.properties ? card.properties.find(p => p && p.objectId === profProp.objectId) : null;

          if (matchedProp) {
            prop = { ...profProp,
              ...matchedProp
            };
          } else if (['givenName', 'familyName', 'emailAddresses', 'phoneNumbers'].includes(name)) {
            prop = profProp;
          }
        }
      }

      if (!prop) return null;
      const vals = extractAllValues(prop);
      return vals && vals.length > 0 ? vals[0] : null;
    } catch (err) {
      return null;
    }
  };

  const extractAllValues = prop => {
    let values = [];

    try {
      if (!prop) return [];

      if (prop.multiple && prop.values && prop.values.length > 0) {
        prop.values.forEach(val => {
          if (typeof val === 'string') values.push(val);else if (val && typeof val === 'object') {
            if (val.value && typeof val.value === 'string') values.push(val.value);else if (val.value && val.value.value) values.push(val.value.value);else if (val.parameters) {
              if (prop.name === 'postalAddresses') {
                // eslint-disable-next-line no-mixed-operators
                const street = val.parameters['1'] && val.parameters['1'].value || '';
                // eslint-disable-next-line no-mixed-operators
                const city = val.parameters['2'] && val.parameters['2'].value || '';
                // eslint-disable-next-line no-mixed-operators
                const state = val.parameters['3'] && val.parameters['3'].value || '';
                // eslint-disable-next-line no-mixed-operators
                const postal = val.parameters['4'] && val.parameters['4'].value || '';
                const addr = [street, city, state, postal].filter(Boolean).join(', ');
                if (addr) values.push(addr);
              } else if (val.parameters['1'] && val.parameters['1'].value) {
                values.push(val.parameters['1'].value);
              }
            }
          }
        });
      } else {
        let val = null;

        if (typeof prop.value === 'string' && prop.value.trim() !== '') {
          val = prop.value;
        } else if (prop.value && typeof prop.value.value === 'string' && prop.value.value.trim() !== '') {
          val = prop.value.value;
        } else if (prop.value && typeof prop.value === 'object' && prop.value.parameters) {
          if (prop.name === 'postalAddresses') {
            // eslint-disable-next-line no-mixed-operators
            const street = prop.value.parameters['1'] && prop.value.parameters['1'].value || '';
            // eslint-disable-next-line no-mixed-operators
            const city = prop.value.parameters['2'] && prop.value.parameters['2'].value || '';
            // eslint-disable-next-line no-mixed-operators
            const state = prop.value.parameters['3'] && prop.value.parameters['3'].value || '';
            // eslint-disable-next-line no-mixed-operators
            const postal = prop.value.parameters['4'] && prop.value.parameters['4'].value || '';
            val = [street, city, state, postal].filter(Boolean).join(', ');
          } else {
            // eslint-disable-next-line no-mixed-operators
            val = prop.value.parameters['1'] && prop.value.parameters['1'].value || null;
          }
        } else if (prop.value && typeof prop.value === 'object' && prop.value.value) {
          val = prop.value.value;
        } else if (prop.parameters) {
          const paramVals = Object.values(prop.parameters).filter(p => p && typeof p.value === 'string').map(p => p.value);
          if (paramVals.length > 0) val = paramVals[0];
        }

        if (val && typeof val === 'object') {
          if (val.value) val = val.value;else val = null;
        }

        if (val) values.push(val);
      }
    } catch (e) {} // Guarantee all items in the array are primitive strings so React never crashes on objects


    return values.map(v => typeof v === 'object' ? JSON.stringify(v) : String(v));
  };

  const getIcon = name => {
    if (name === 'phoneNumbers' || name === 'phone') return '📞';
    if (name === 'emailAddresses' || name === 'email') return '✉️';
    if (name === 'urlAddresses' || name === 'website' || name === 'domain') return '🌐';
    if (name === 'postalAddresses' || name === 'address') return '📍';
    if (name === 'dates' || name === 'birthday') return '📅';
    if (name === 'socialProfiles' || name === 'facebook' || name === 'twitter' || name === 'instagram' || name === 'linkedin') return '🔗';
    if (name === 'jobTitle' || name === 'department' || name === 'company') return '💼';
    if (name === 'note' || name === 'onmymind') return '📝';
    return '🔹';
  };

  const formatPropertyLabel = name => {
    if (!name || typeof name !== 'string') return 'Property';
    const labelMap = {
      'emailAddresses': 'Email',
      'phoneNumbers': 'Phone',
      'postalAddresses': 'Address',
      'urlAddresses': 'Website',
      'jobTitle': 'Job Title',
      'department': 'Department',
      'company': 'Company',
      'domain': 'Domain',
      'birthday': 'Birthday',
      'onmymind': 'On My Mind',
      'howisaymyname': 'How I Say My Name',
      'facebook': 'Facebook',
      'linkedin': 'LinkedIn',
      'twitter': 'Twitter',
      'instagram': 'Instagram',
      'gender': 'Gender',
      'religion': 'Religion',
      'astrological': 'Astrological Sign',
      'note': 'Note',
      'email': 'Email',
      'phone': 'Phone',
      'address': 'Address',
      'website': 'Website'
    };
    if (labelMap[name]) return t(labelMap[name]);
    return t(name.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim());
  };

  const getThumbnail = () => {
    let image = extractSingleVal('thumbnailImage') || extractSingleVal('thumbNailImage') || extractSingleVal('photo');

    if (image && typeof image === 'string' && !image.startsWith('data:image') && !image.startsWith('http')) {
      return `data:image/jpeg;base64,${image}`;
    }

    return image;
  };

  const prefix = extractSingleVal('prefix') || extractSingleVal('namePrefix') || '';
  const firstName = extractSingleVal('givenName') || '';
  const middleName = extractSingleVal('middleName') || '';
  const lastName = extractSingleVal('familyName') || '';
  const suffix = extractSingleVal('suffix') || extractSingleVal('nameSuffix') || '';
  // eslint-disable-next-line no-useless-escape
  const suffixStr = typeof suffix === 'string' && suffix ? suffix.match(/^[,\.]/) ? suffix : ` ${suffix}` : '';
  const fullName = `${prefix} ${firstName} ${middleName} ${lastName}`.replace(/\s+/g, ' ').trim() + suffixStr;
  const finalName = fullName.trim() || 'No Name Set';
  const pronoun = extractSingleVal('pronoun');
  const nickName = extractSingleVal('nickName');
  const company = extractSingleVal('company');
  const jobTitle = extractSingleVal('jobTitle');
  const department = extractSingleVal('department');
  const thumbnail = getThumbnail();
  const headerProps = ['prefix', 'namePrefix', 'givenName', 'middleName', 'familyName', 'suffix', 'nameSuffix', 'pronoun', 'nickName', 'company', 'jobTitle', 'department', 'thumbnailImage', 'thumbNailImage', 'photo', 'avatar', 'customContactsLists', 'fullName', 'fn'];
  const excludedObjectIds = new Set();

  if (profile && profile.properties) {
    profile.properties.forEach(p => {
      if (p && p.name && headerProps.includes(p.name) && p.objectId) {
        excludedObjectIds.add(p.objectId);
      }
    });
  }

  const otherProps = card.properties ? card.properties.filter(p => {
    if (!p) return false;
    if (p.name && headerProps.includes(p.name)) return false;
    if (p.name && typeof p.name === 'string' && headerProps.includes(p.name.toLowerCase())) return false;
    if (p.objectId && excludedObjectIds.has(p.objectId)) return false;
    return true;
  }) : []; // Unique properties to avoid duplicates

  const uniqueProps = [];
  const seenValues = new Set();
  otherProps.forEach(prop => {
    const values = extractAllValues(prop);

    if (values && values.length > 0) {
      // Pick first value for uniqueness check, though we map them later
      const key = `${prop.name}:${values[0]}`;

      if (!seenValues.has(key)) {
        seenValues.add(key);
        uniqueProps.push(prop);
      }
    }
  });
  const contactProps = uniqueProps.filter(p => ['emailAddresses', 'email', 'phoneNumbers', 'phone', 'urlAddresses', 'website', 'postalAddresses', 'address'].includes(p.name));
  const socialProps = uniqueProps.filter(p => ['facebook', 'linkedin', 'twitter', 'instagram', 'social'].includes(p.name) || p.group === 'social');
  const personalProps = uniqueProps.filter(p => ['birthday', 'religion', 'astrological', 'onmymind', 'howisaymyname', 'gender', 'note'].includes(p.name) || p.group === 'personal');
  const categorizedPropNames = new Set([...contactProps.map(p => p.name), ...socialProps.map(p => p.name), ...personalProps.map(p => p.name)]);
  const remainingProps = uniqueProps.filter(p => !categorizedPropNames.has(p.name));

  const renderPropertyGroup = (title, props) => {
    if (props.length === 0) return null;
    return <div className="category-group" key={title}>
                <div className="category-title">{title}</div>
                {props.map((prop, index) => {
        const values = extractAllValues(prop);
        if (!values || values.length === 0) return null;
        const icon = getIcon(prop.name);
        const labelText = prop.showName || formatPropertyLabel(prop.name);
        return values.map((val, vIdx) => <div className="property-row" key={`${prop.objectId || prop.name}-${index}-${vIdx}`}>
                            <div className="property-icon" title={labelText}>{icon}</div>
                            <div className="property-info">
                                <span className="contact-label">{labelText}</span>
                                <span className="contact-value">{val}</span>
                            </div>
                        </div>);
      })}
            </div>;
  };

  return <div className="modern-card-preview">
            <div className="real-business-card">
                
                <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        width: '100%',
        boxSizing: 'border-box'
      }}>

                {thumbnail ? <div className="photo-container">
                        <img src={thumbnail} alt={t("Profile")} className="photo-image" />
                    </div> : <div className="photo-container">
                        <div className="photo-image initials-container">
                            <span className="initials-text">
                                {(() => {
                const first = typeof firstName === 'string' && firstName ? firstName.charAt(0) : '';
                const last = typeof lastName === 'string' && lastName ? lastName.charAt(0) : '';
                const initials = (first + last).toUpperCase();
                if (initials) return initials;

                if (typeof finalName === 'string' && finalName && finalName !== 'No Name Set') {
                  const parts = finalName.split(' ');

                  if (parts.length > 1) {
                    return (String(parts[0]).charAt(0) + String(parts[parts.length - 1]).charAt(0)).toUpperCase();
                  }

                  return finalName.charAt(0).toUpperCase();
                }

                return 'H';
              })()}
                            </span>
                        </div>
                    </div>}

                <div className="card-header">
                    <div className="card-header-top">
                        <h2 className="card-name">{card.name ? t(card.name) : t('Card')}</h2>
                    </div>
                    {company && <h3 className="company-name">{company.toUpperCase()}</h3>}
                </div>

                <div className="main-info">
                    {finalName !== 'No Name Set' && <h1 className="person-name">
                            {finalName.toUpperCase()}
                            {pronoun && <span style={{
              fontSize: '0.6em',
              color: '#666',
              marginLeft: '8px',
              fontWeight: 'normal'
            }}>({pronoun})</span>}
                        </h1>}
                    {nickName && <p className="person-nickname">"{nickName}"</p>}
                    {department && <p className="person-department">{department}</p>}
                    {jobTitle && <p className="person-title">{jobTitle}</p>}
                </div>

                <div className="contact-section">
                    {renderPropertyGroup(t('Contact'), contactProps)}
                    {renderPropertyGroup(t('Social'), socialProps)}
                    {renderPropertyGroup(t('Personal'), personalProps)}
                    {renderPropertyGroup(t('Other'), remainingProps)}
                </div>

                <div className="card-footer">
                    <p className="brand-text">{t("HeresMyInfo")}</p>
                </div>
                
                </div>
            </div>
        </div>;
}